module.exports = __webpack_public_path__ + "img/web-top-menu.89b1510c.jpg";